import { AnimatePresence, motion } from 'motion/react';

interface FileDropZoneProps {
  show: boolean;
  message?: string;
}

export function FileDropZone({
  show,
  message = 'Drop files here to upload',
}: FileDropZoneProps) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="file-drop-zone"
          initial={{ opacity: 0, backdropFilter: 'blur(0px)' }}
          animate={{ opacity: 1, backdropFilter: 'blur(2px)' }}
          exit={{
            opacity: 0,
            backdropFilter: 'blur(2px)',
            transition: {
              type: 'keyframes',
              ease: 'easeInOut',
              duration: 0.1,
            },
          }}
          className="absolute top-0 left-0 w-full size-full z-50 flex items-center justify-center pointer-events-none"
        >
          <p className="text-foreground text-xl">{message}</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
